module.exports = __webpack_public_path__ + "img/nav-39.c15ab11f.png";